import { formatCurrency } from '../formatters';
import { useCulture } from './useCulture';

/**
 * Returns parameter `value` formatted as the currency.
 * @see {@link formatCurrency} for more information.
 *
 * @param value Numeric value to format
 * @param options Additional formatting options
 * @returns `value` formatted as the currency
 * @example
  // basic usage
  useFormatCurrency(1234.567);

  // use a custom delimiter
  useFormatCurrency(1234.567, { doubleCurrencyDelimiter: ' | ' });
 */
export function useFormatCurrency(value, options) {
  const {
    culture,
    financialSet
  } = useCulture();
  return formatCurrency(value, culture, financialSet, options);
}
//# sourceMappingURL=useFormatCurrency.js.map